module.exports = __webpack_public_path__ + "static/media/4.8eb07230.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/01/projects/01/4.jpg
// module id = 395
// module chunks = 0